import styled from "styled-components";

export const SellingPriceContainer = styled.div`
  box-shadow: 0 4px 4px rgb(0 0 0 / 25%);
  padding: 10px 15px;
  border: 1px solid #979797;
  border-radius: 4px;
  margin-bottom: 1rem;
`;

export const ServiceTitleConatiner = styled.div`
  background: #008395;
  display: flex;
  -webkit-box-pack: justify;
  justify-content: space-between;
  margin: -10px -15px;
  margin-bottom: 1rem;
`;

export const Title = styled.h2`
  font-family: "Lato";
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 1;
  color: #fff;
  text-transform: initial;
  padding-left: 10px;
}
`;

export const GridRow = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.column ?? "1fr"};
  gap: ${(props) => props.gap ?? "1.25rem"};
  margin-top: ${(props) => props.marginTop ?? "0px"};
`;

export const MarginContainer = styled.div`
  margin: 2rem 0 2rem 0;
  > div {
    display: inline-flex;
    align-items: center;
  }
`;

export const MarginLabel = styled.h2`
  font-family: "Lato";
  font-style: normal;
  font-weight: bold;
  font-size: 1rem;
  line-height: 1;
  color: #1bace4;
  margin: 0;
  display: inline-block;
  text-transform: initial;
`;

export const MarginValue = styled.span`
  font-family: "Lato";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 1;
  margin-left: 0.5rem;
  color: ${(props) => props.color};
`;

export const CommentContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.625rem;
  margin-top: 1rem;
`;

export const ExchangeRateContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  > div {
    position: relative;
  }
`;

export const ExchangeRateInputLabel = styled.label`
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 1rem;
  line-height: 1;
  color: #1bace4;
  text-transform: capitalize;
  z-index: 1;
  width: auto;
  transition: transform 150ms ease-out, font-size 150ms ease-out;
  background-color: transparent;
  &::after {
    content: "*";
    color: #ea6457;
    font-weight: bold;
  }
`;

export const ExchangeRateInput = styled.input`
  position: relative;
  width: 100%;
  outline: 0;
  box-shadow: 0 1px 0 0 #e5e5e5;
  transition: box-shadow 150ms ease-out;
  background-color: white;
  border-radius: 4px;
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 1rem;
  line-height: 1;
  color: #474747;
  box-sizing: border-box;
  padding: 7px 5px 7px 10px;
  border: ${(props) =>
    props.value ? "1px solid #32a728" : "1px solid #474747"};
  &:focus,
  &:active {
    outline: none;
    border: 1px solid #1bace4 !important;
  }
`;

export const ExchangeRateErrorMessage = styled.p`
  width: 100%;
  color: red;
  font-size: 0.875rem;
  font-family: Lato;
  line-height: 1;
  margin: 0;
  padding: 0;
  position: absolute;
`;

export const PriceContainer = styled.div`
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
`;

export const PricePerUnit = styled.div`
  margin-left: 0.5rem;
  font-size: 1rem;
  font-family: Lato;
  color: #474747;
`;

export const LoadingContainer = styled.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  margin-left: 0.5rem;
`;

export const DestinationAddress = styled.h3`
  margin: 0;
  font-size: 14px;
  font-family: "Lato";
  color: #ff540a;
  line-height: 1;
`;

export const ErrorDiv = styled.div`
  height: auto;
  border: solid 1px red;
  padding: 5px 7px 5px 7px;
  margin-top: 10px;
`;
